import { generatePath, useLocation } from 'react-router-dom';
import { RoutePath } from 'router/routes/routePath';
import { StructureQueryType } from 'api/graphql/hooks/structures/useGetAncestors';
import { structureStart } from 'components/breadcrumbs/constants/staticCrumbs';
import { StructureType } from 'api';

export const singleStructureCrumb = ({ 
    name, 
    id, 
    type, 
    directoryId 
}: { 
    name: string; 
    id: string; 
    type?: string;
    directoryId?: string;
}) => {
    if (type === StructureType.GENERAL_MODE && directoryId) {
        return {
            name,
            path: generatePath(RoutePath.StructuresDirectory, { 
                structureId: id,
                directoryId 
            }),
        };
    }
    
    return {
        name,
        path: generatePath(RoutePath.StructuresPreview, { structureId: id }),
    };
};

export const generateStructureCrumb = (data: StructureQueryType | undefined) => {
    return [
        ...structureStart,
        ...(data?.structure.ancestors.map(({ name, id, type }) => 
            singleStructureCrumb({ name, id, type })
        ) || []),
        singleStructureCrumb({
            name: data?.structure.name as string,
            id: data?.structure.id ?? '',
            type: data?.structure.type,
        }),
    ];
};

export const generateReferenceBreadcrumb = (
    data: StructureQueryType | undefined,
    referenceStructureId: string | null,
) => {
    if (!data?.structure) return structureStart;

    const { structure } = data;
    const ancestors = structure.ancestors || [];

    const referenceIndex =
        structure.id === referenceStructureId
            ? ancestors.length
            : ancestors.findIndex((a) => a.id === referenceStructureId);

    const relevantAncestors = referenceIndex >= 0 ? ancestors.slice(referenceIndex) : ancestors;

    return [
        ...relevantAncestors.map(({ name, id, type }) => 
            singleStructureCrumb({ name, id, type })
        ),
        singleStructureCrumb({ 
            name: structure.name, 
            id: structure.id,
            type: structure.type,
        }),
    ];
};

export const useOrganizationDetailsCrumb = () => {
    const { state } = useLocation();

    if (state?.id) {
        return {
            name: state.name,
            path: generatePath(RoutePath.OrganizationDetails, {
                organizationId: state.id as string,
            }),
        };
    }
};
